export default "__VITE_ASSET__B$rnFcH9__"